// extracted by mini-css-extract-plugin
export default {"wrapper":"Wrapper_wrapper__RU5Si","content":"Wrapper_content__m77YI","isErrorContent":"Wrapper_isErrorContent__SIFCF","error":"Wrapper_error__JH280"};